import shared_sensors_utils from '../../../../backbone-unorganized/shared/sensors/util';
import { BaseFieldView } from '../BaseField/views';
import { TemperatureFieldView } from '../../../features/mobileForm/temperatureField/views';
import { isWeb, isWindows } from '../../../../shared/utils/is';

export const SensorTemperatureItem = TemperatureFieldView.extend({
    template: '#tpl_sensor_temperature_field_item',
    model: null, // SensorTemperature,
    tagName: 'li',
    className: 'sensor_readings',

    events: _.extend(
        {
            'click .sensor_refresh_temp': 'refreshSensorReadings'
        },
        TemperatureFieldView.prototype.events
    ),

    templateHelpers: function () {
        const placement = this.model.get('placement');
        const isValidTemperatureReading = this.isValidTemperatureReading(
            this.model.get('is_online'),
            this.model.get('last_reading_date'),
            this.model.get('last_reading_value')
        );
        const isActiveSubmission = !this.model.get('is_submitted_value');

        return $.extend(SensorTemperatureItem.__super__.templateHelpers.apply(this, arguments), {
            timestamp: shared_sensors_utils.get_formatted_sensor_timestamp({
                time_zone: $f.active_user.get('time_zone'),
                timestamp: this.model.get('last_reading_date'),
                format: $f.utils.DATE_AND_TIME_FMT
            }),
            value: $f.utils.convert_to_users_temperature_units(this.model.get('last_reading_value')),
            placementName: placement ? placement.name : '',
            isActiveSubmissionWithInvalidTempReading: isActiveSubmission && !isValidTemperatureReading,
            isValidTemperatureReading,
            isActiveSubmission
        });
    },

    refreshSensorReadings: function () {
        $f.application.vent.trigger('sensor:refresh_readings');
    },

    getTemplate: function () {
        return this.template;
    },

    on_change_action: function () {
        this._scroll_down_one_field();
    },

    _should_force_temperature_probe: function () {
        if (isWindows() || isWeb()) {
            return false;
        }

        return this.model.collection.form_collection.metadata.get('is_force_probe_input');
    },

    isValidTemperatureReading(isOnline, lastReadingDate, lastReadingValue) {
        return shared_sensors_utils.isValidSensorTemperatureReading(isOnline, lastReadingDate, lastReadingValue);
    }
});

export const SensorTemperatureItemList = Backbone.Marionette.CollectionView.extend({
    itemView: SensorTemperatureItem,
    collection: null, // SensorTemperatures

    initialize: function (options = {}) {
        $.extend(this, options);
    }
});

export const SensorTemperatureFieldView = BaseFieldView.extend({
    template: '#tpl_sensor_temperature_field',
    model: null, // MobileSensorTemperatureField

    regions: {
        r_sensor_temperatures_list: '.sensor_temperatures_list'
    },

    getTemplate: function () {
        return this.template;
    },

    initialize: function (options) {
        // tied to the location field
        const account_field = this.model.collection.findWhere({ type: 'account' });
        if (!account_field) {
            return;
        }

        options = options || {};
        $.extend(this, options);

        const location_id = account_field.get('value');

        if (location_id && !this.form_collection.has_been_submitted()) {
            this.model.set_initial_location(location_id);
        }

        if (this.form_collection.has_been_submitted()) {
            this.model.sensor_collection.set_submitted_values(this.model.get('value') || []);
        }

        SensorTemperatureFieldView.__super__.initialize.apply(this, arguments);

        this.listenTo(account_field, 'change:value', () => this.model.change_location(account_field.get('value')));
        this.listenTo(this.model.sensor_collection, 'change add remove', this.save_value);
        this.listenTo($f.application.vent, 'sensor:refresh_readings', this.refreshReadings);
    },

    save_value: function () {
        this.model.set(
            'value',
            this.model.sensor_collection.map((sensor) => ({
                id: sensor.get('id'),
                name: sensor.get('name'),
                placement: sensor.get('placement'),
                timestamp: sensor.get('is_online') ? sensor.get('last_reading_date') : null,
                value: this.getSensorReadingValue(sensor),
                reading_method: sensor.get('reading_method')
            }))
        );
        this.model.trigger('change', this.model);
    },

    getSensorReadingValue: function (sensor) {
        const isValidTemperatureReading = this.isValidTemperatureReading(
            sensor.get('is_online'),
            sensor.get('last_reading_date'),
            sensor.get('last_reading_value')
        );

        if (!isValidTemperatureReading) {
            return sensor.get('value');
        }

        if (isValidTemperatureReading) {
            return sensor.get('last_reading_value');
        }

        return null;
    },

    isValidTemperatureReading: function (isOnline, lastReadingDate, lastReadingValue) {
        return shared_sensors_utils.isValidSensorTemperatureReading(isOnline, lastReadingDate, lastReadingValue);
    },

    onRender: function () {
        this.r_sensor_temperatures_list.show(
            new SensorTemperatureItemList({
                collection: this.model.sensor_collection
            })
        );
    },

    handle_change: function () {}, // don't re-render on save; sub-view's will do that themselves

    refreshReadings: function () {
        this.$el.find('.sensor_refresh_temp').hide();
        this.$el.find('.sensor_status_info_box.retry_action .loading_spinner').show();

        this.model.sensor_collection.fetch({
            success: () => {
                this.render();
            },
            error: () => {
                this.$el.find('.loading_spinner').hide();
                this.$el.find('.df-refresh-alert').show();
            }
        });
    }
});
